module.exports = __webpack_public_path__ + "static/media/step-indicator-3.23f72e4c.svg";